// icon-data/index.ts — entry point for the icon registry bundle (esbuild IIFE → dist/icon-lookup.js).
//
// Loaded as a footer <script> BEFORE core-helpers.js, it publishes the front-end-owned icon registry on
// window.FT_ICON_REGISTRY, which the global iconMap() (core-helpers.js) reads at call time. This is the
// cacheable static asset that REPLACES the old per-request inline window.ICON_LOOKUP blob — the icon
// data now lives in front-end TS files (icon-data/catalogs/*.ts), not in PHP. See
// plans/icon-map-from-php-is-misty-otter.md (Phase 2).

import type { IconMap } from './types';
import { ICON_REGISTRY } from './registry';

declare global {
    interface Window {
        FT_ICON_REGISTRY?: IconMap;
        ICON_LOOKUP?: IconMap;
    }
}

window.FT_ICON_REGISTRY = ICON_REGISTRY;

// Back-compat alias: window.ICON_LOOKUP used to be the PHP-built inline blob (ft_boot). Several
// consumers still read it directly — iconMap (core-helpers.js), the combat-log renderer
// (log-render.ts), the XZ ruler (xz-ruler.ts), the map-marker pickers (locations-init.js,
// template.js). Point it at the SAME front-end registry so they keep working while the PHP emission
// is removed (plans/icon-map-from-php-is-misty-otter.md Phase 2). Same {file,tooltip} shape as before.
window.ICON_LOOKUP = ICON_REGISTRY;

export {};
